
// Store impersonation token in memory
let impersonationToken = null;

export const setImpersonationToken = (token) => {
  impersonationToken = token;
};

export const clearImpersonationToken = () => {
  impersonationToken = null;
};

export const getImpersonationToken = () => {
  return impersonationToken;
};

const createConfigRequest = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache'
  };

  return {
    credentials: 'include',
    headers,
    cache: 'no-store'
  };
};

export const api = {
  get: async (url) => {
    const config = createConfigRequest();
    return fetch(url, {
      method: 'GET',
      ...config
    });
  },

  post: async (url, data) => {
    const config = createConfigRequest();
    return fetch(url, {
      method: 'POST',
      ...config,
      body: JSON.stringify(data)
    });
  },

  put: async (url, data) => {
    const config = createConfigRequest();
    return fetch(url, {
      method: 'PUT',
      ...config,
      body: JSON.stringify(data)
    });
  },

  delete: async (url, data) => {
    const config = createConfigRequest();
    return fetch(url, {
      method: 'DELETE',
      ...config,
      ...(data !== undefined ? { body: JSON.stringify(data) } : {})
    });
  },

  patch: async (url, data) => {
    const config = createConfigRequest();
    return fetch(url, {
      method: 'PATCH',
      ...config,
      body: JSON.stringify(data)
    });
  }
}; 